import { useState } from 'react';

/**
 * A common hook to be used to control simple dialog open/close
 * @returns State and handler for dialog
 */
export default function useDialogVisibilityHook() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleDialogVisibilityToggle = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  const setDialogVisibility = (visibility) => {
    setIsDialogOpen(visibility);
  };
  return { isDialogOpen, handleDialogVisibilityToggle, setDialogVisibility };
}
